"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOutActionExtended = isOutActionExtended;
exports.isOutActionBasic = isOutActionBasic;
function isOutActionExtended(action) {
    return (action.type === 'setIsPublicKeyEnabled' || action.type === 'addExtension' || action.type === 'removeExtension');
}
function isOutActionBasic(action) {
    return !isOutActionExtended(action);
}
